import { formatDistanceToNow } from "date-fns";

/** Fixed grid-card height so empty and full cards align in the grid. */
export const LIST_CARD_GRID_HEIGHT_CLASS = "h-[172px]";

/**
 * Even card padding. Do NOT add a card-wide `pr-*` for owner actions —
 * that left a permanent empty gutter under the top-right hover controls.
 * Reserve space on the title only via LIST_CARD_TITLE_*_RESERVE_CLASS.
 */
export const LIST_CARD_GRID_OPEN_BTN_CLASS =
  "flex w-full cursor-pointer flex-col justify-between rounded-[inherit] border-0 bg-transparent p-5 pb-4 text-left shadow-none";

/** Title-only inset so truncated text clears two circular hover actions. */
export const LIST_CARD_TITLE_RENAME_DELETE_RESERVE_CLASS = "pr-20";

/** Title-only inset so truncated text clears one circular delete control. */
export const LIST_CARD_TITLE_DELETE_RESERVE_CLASS = "pr-12";

/**
 * Relative-time line on list cards — matches sidebar Recents meta
 * (SIDEBAR_ITEM_META_STYLE: 11px / 14px).
 */
export const LIST_CARD_RELATIVE_TIME_CLASS =
  "text-[11px] leading-[14px] text-puntt-neutral-gray-10";

/** Absolute calendar date for list cards (sidebar uses relative only). */
export function formatListCardAbsoluteDate(
  iso: string | Date | undefined,
): string {
  if (iso == null || iso === "") return "";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/** Relative time for list cards (e.g. "3 days ago"). */
export function formatListCardRelativeDate(
  iso: string | Date | undefined,
): string {
  if (iso == null || iso === "") return "";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return "";
  return formatDistanceToNow(d, { addSuffix: true });
}

export function listCardTimestampIso(
  updatedAt?: string | Date | null,
  createdAt?: string | Date | null,
): string | Date | undefined {
  const value = updatedAt ?? createdAt;
  if (value == null || value === "") return undefined;
  return value;
}
